import axios from 'axios';

export const ACTING_CHARACTER_HEADER = 'X-Acting-Character';

/*
 * `/game` and `/game/training` are separate routes that resolve different
 * characters at the same time, so the character a request acts as travels with
 * the request instead of being stored on the client. The header is deliberately
 * absent from the OpenAPI schema — declaring it would have shifted a positional
 * argument on some fifty generated methods — so it is attached here, once, for
 * everything the training route calls.
 */
let actingCharacterId = null;

/*
 * These two write `main_character`. Acting as a training clone must never reach
 * them, whatever ends up calling them.
 */
const FORBIDDEN_PATHS = [
    '/character/player/select_character',
    '/character/player/create_character',
];

export function setActingCharacter(characterId) {
    actingCharacterId = characterId || null;
}

export function clearActingCharacter() {
    actingCharacterId = null;
}

export function getActingCharacter() {
    return actingCharacterId;
}

export function actingHeaderFor(url) {
    if (!actingCharacterId) return null;
    const target = String(url || '');
    if (!target.includes('/api/')) return null;
    if (FORBIDDEN_PATHS.some((path) => target.includes(path))) return null;
    return actingCharacterId;
}

export function installActingCharacterHeader() {
    axios.interceptors.request.use((config) => {
        const id = actingHeaderFor(`${config.baseURL ?? ''}${config.url ?? ''}`);
        if (id) {
            config.headers = config.headers || {};
            config.headers[ACTING_CHARACTER_HEADER] = id;
        }
        return config;
    });
}
